import { lookupEntities } from '../../constants/metadataConstants';
import { getEntityOption } from '../../helpers/entityOptionHelper';

export const filterLookupBaseOptions = {
  [lookupEntities.TicketLookup]: {
    getItem(item) {
      return getEntityOption(item, { url: item.campaign.urlPath });
    }
  },
  [lookupEntities.MerchandiseLookup]: {
    getItem(item) {
      return getEntityOption(item);
    }
  }
};
